import axios from './index';

let base = 'dashboard/user-devices';

class DeviceApi {
    static List = (userId) => {
        return axios.get(`${base}?userId=${userId}`);
    };
}

export default DeviceApi;
